












import {Component, Vue, Prop} from "vue-property-decorator";
import * as session from "../session";

@Component({})
export default class TopNav extends Vue {
    protected identity: string = "loading...";

    public created() {
        session.me().then((u: any) => {
            this.identity = `${u.displayname} (${u.username})`;
        });
    }
}
